<div class="chart-modal" *transloco="let t; prefix: 'maintenanceOverview.modals.reactiveGraph'">
  <!-- Header row -->
  <div class="chart-modal__header">
    <!-- Left: Title + Trend -->
    <div class="title-and-trend">
      <h3 class="chart-title">{{ title }}</h3>

      @if (!isLoading && hasData()) {
        <app-graph-trend-icon
          [percentageChange]="percentageChange"
          [formattedChange]="formatPercentChange()"
          [formatValue]="formatValue()"
          [isUptrendPositive]="isUptrendPositive()">
        </app-graph-trend-icon>
      }
    </div>

    <!-- Right: Filters + menu + close -->
    <div class="chart-modal__header-actions">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter
          [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)">
        </app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals"
            [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>

      <!-- close -->
      <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="chart-modal__body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasData()) {
        <div class="chart-modal__chart">
          <app-horizontal-bar-chart
            [data]="chartData"
            [referenceLines]="referenceLines">
          </app-horizontal-bar-chart>
        </div>

        <!-- Legend + Export -->
        <div class="chart-modal__legend">
          <div class="legend-items">
            @for (item of legendItems; track item.name) {
              <div class="legend-item">
                <span class="legend-color" [style.background-color]="item.color"></span>
                <span class="legend-label">{{ item.name }}</span>
              </div>
            }
          </div>

          <div hidden ngbDropdown #exportDropdown="ngbDropdown" class="export-dropdown" [autoClose]="true" placement="top-end">
            <button
              class="export-btn"
              type="button"
              ngbDropdownToggle
              [disabled]="isExporting">
              <span>{{ isExporting ? t('exporting') : t('export') }}</span>
              @if (!isExporting) {
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  <path d="M8 7l4-4 4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
              }
            </button>

            <ul ngbDropdownMenu class="dropdown-menu export-menu" aria-labelledby="export-dropdown">
              <li>
                <a ngbDropdownItem class="dropdown-item" (click)="onExportExcel(); exportDropdown.close()">{{ t('exportAsExcel') }}</a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item" (click)="onExportCsv(); exportDropdown.close()">{{ t('exportAsCsv') }}</a>
              </li>
            </ul>
          </div>
        </div>
      } @else if (!isLoading && !hasData()) {
        <div class="chart-modal__empty">
          <app-empty-state></app-empty-state>
        </div>
      }
    }

    @if (isLoading) {
      <div class="chart-modal__loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    }
  </div>
</div>